import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedContactDrawer, toggleContactDrawerOpen } from '../slice';
const mobileNewContactButtonCss = "mwwy5rm";
const MobileNewContactButton = forwardRef((props, ref) => <MinimalButton ref={ref} {...props} className={classNames(mobileNewContactButtonCss, props.className)} />);
const newContactContainerCss = "neu7qyr";
const NewContactContainer = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(newContactContainerCss, props.className)} />);
export const OpenNewContactDrawerButton = ({
  decoration = 'primary',
  mobile = false
}) => {
  const dispatch = useDispatch();
  const openNewContactDrawer = () => {
    dispatch(setSelectedContactDrawer('NEW_CONTACT_FORM'));
    dispatch(toggleContactDrawerOpen());
  };
  if (mobile) {
    return <MobileNewContactButton size="small" onClick={openNewContactDrawer}>
        <AddMiniIcon />
        {I18n.t('publisher.contacts.buttons.add_contact')}
      </MobileNewContactButton>;
  }
  if (decoration === 'bare') {
    return <NewContactContainer onClick={openNewContactDrawer}>
        <AddMiniIcon />
        {I18n.t('publisher.contacts.buttons.add_contact')}
      </NewContactContainer>;
  }
  return <Button decoration={decoration} onClick={openNewContactDrawer}>
      <AddMiniIcon />
      {I18n.t('publisher.contacts.buttons.add_contact')}
    </Button>;
};

require("./open_new_contact_drawer_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./open_new_contact_drawer_button.js");